var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { alt: "", src: "images/jiadian_shorthight.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("平安家居/充电桩安装运维工雇主险")]),
                  _c("div", [
                    _vm._v(
                      "行业首选方案 | 中国平安产险承保 | 家电/家居/充电桩行业可保"
                    ),
                  ]),
                  _c("div", { staticStyle: { margin: "15px 0" } }, [
                    _c("i", {
                      staticClass: "el-icon-success",
                      staticStyle: { color: "#409eff", "font-size": "18px" },
                    }),
                    _vm._v(
                      "\n\t\t\t\t\t住院误工费最长可赔付365天，包含自费药，赔付80%\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _c("i", {
                      staticClass: "el-icon-success",
                      staticStyle: { color: "#409eff", "font-size": "18px" },
                    }),
                    _vm._v(
                      "\n\t\t\t\t\t附加第三者责任，保障第三者人员伤亡\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _c("i", {
                      staticClass: "el-icon-error",
                      staticStyle: { color: "red", "font-size": "18px" },
                    }),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("本方案存在禁保地区"),
                    ]),
                    _c("br"),
                    _c("i", {
                      staticClass: "el-icon-error",
                      staticStyle: { color: "red", "font-size": "18px" },
                    }),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("猝死事故死亡赔偿限额为50%"),
                    ]),
                    _c("br"),
                    _c("i", {
                      staticClass: "el-icon-error",
                      staticStyle: { color: "red", "font-size": "18px" },
                    }),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("延迟报案须扣除免赔额或无法赔付"),
                    ]),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      "cell-style": _vm.onCellStyle,
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c("el-card", { attrs: { header: "赔付标准" } }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t1、医疗费用（含自费药）：赔付比例为80%，检查费用以2000元为限。\n\t\t\t\t\t"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t2、误工费：100元/天（按住院天数计算误工时间，365天为限）\n\t\t\t\t\t"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t3、死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。对本保单项下发生的猝死事故，赔付金额以保单约定死亡限额的50%为限。\n\t\t\t\t\t"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t4、伤残：伤残等级赔偿限额比例表。\n\t\t\t\t\t"
                  ),
                  _c("br"),
                  _c(
                    "div",
                    { staticStyle: { margin: "10px 0" } },
                    [
                      _c(
                        "avue-crud",
                        {
                          ref: "crud",
                          attrs: {
                            data: _vm.dataBenefit,
                            option: _vm.optionBenefit,
                          },
                        },
                        [_c("template", { slot: "header" })],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n\t\t\t\t\t5、延迟报案：被保险人须在保险事故发生后的48小时内向保险人报案。超48小时报案，视为延迟报案，保险人对保险责任范围内的损失按绝对免赔率30%定损。因延迟报案致使保险人对保险事故的性质、原因、损失程度等难以查勘定损确定的，保险人对于无法核实确定的部分，不承担赔偿责任。\n\t\t\t\t"
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (ref) {
                        var question = ref.question
                        if (question === void 0) question = ""
                        var answer = ref.answer
                        if (answer === void 0) answer = ""
                        return _c(
                          "li",
                          { key: question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(question))]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-top": "12px",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "20px",
                                      height: "28px",
                                      "background-color": "MediumSeaGreen",
                                      color: "white",
                                      padding: "4px",
                                      "border-radius": "4px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                                question === "中途是否可以加人？如何收费？"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t中途可以增加保障人员。新增人员时，根据该保单剩余的保障月数计算保费，剩余不足一个月的按一个月计算。\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "table",
                                          {
                                            staticStyle: { margin: "15px" },
                                            attrs: {
                                              border: "1",
                                              cellpadding: "0",
                                              ellspacing: "0",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("th", [_vm._v("剩余月数")]),
                                                _vm._l(12, function (item) {
                                                  return _c("th", [
                                                    _vm._v(
                                                      _vm._s(item) + "个月"
                                                    ),
                                                  ])
                                                }),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("td", [_vm._v("支付比例")]),
                                                _vm._l(
                                                  _vm.questionDataRate,
                                                  function (item) {
                                                    return _c("td", [
                                                      _vm._v(_vm._s(item)),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t保单2021年4月30日24点到期，批增人员2020年5月15日起保按照年度保费的100%收取，若批增人员在6月1日起保按照年度保费的95%收取。\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-wrap",
                                        },
                                      },
                                      [_vm._v(_vm._s(answer))]
                                    ),
                              ]
                            ),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "26px",
                          "white-space": "pre-line",
                        },
                      },
                      [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本产品由中国平安财产保险股份有限公司（以下简称“中国平安”）承保，由中国平安委托博维保险经纪有限公司（以下简称“博维”）进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t中国平安财产保险股份有限公司成立于1988年，总部位于深圳，经营区域覆盖全国，在国内各省市、自治区设有35家二级机构，1100多个营业网点。截止2022年第4季度，公司综合偿付能力充足率为220%，满足监管要求。公司最近一期的风险综合评级结果为BBB。\n\t\t\t\t\t\t"
                        ),
                        _c("h3", [_vm._v("一、重要告知")]),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t1、订立本合同时，本公司应向投保人说明本合同的内容。\n\t\t\t\t\t\t\t2、对保险条款中免除本公司责任的条款，本公司在订立合同时应当在投保界面、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容向投保人作出明确说明，未作提示或者明确说明的，该条款不产生效力。\n\t\t\t\t\t\t\t3、本公司就投保人和被保险人的有关情况提出询问，投保人应当如实告知。\n\t\t\t\t\t\t\t4、如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响本公司决定是否同意承保或者提高保险费率的，本公司有权解除本合同。\n\t\t\t\t\t\t\t5、如果投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，并不退还保险费。\n\t\t\t\t\t\t\t6、如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，但应当退还保险费。\n\t\t\t\t\t\t\t7、本公司在合同订立时已经知道投保人未如实告知的情况的，本公司不得解除合同；发生保险事故的，本公司承担给付保险金的责任。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("h3", [_vm._v("二、产品信息")]),
                        _c(
                          "table",
                          {
                            staticStyle: { margin: "15px" },
                            attrs: {
                              border: "1",
                              cellpadding: "0",
                              ellspacing: "0",
                              width: "100%",
                            },
                          },
                          [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "50%",
                                    padding: "5px 0",
                                  },
                                },
                                [_vm._v("备案名称")]
                              ),
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "50%",
                                    padding: "5px 0",
                                  },
                                },
                                [_vm._v("注册号")]
                              ),
                            ]),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c(
                                  "td",
                                  { staticStyle: { padding: "5px 0" } },
                                  [_vm._v("平安雇主责任保险（A款）")]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { padding: "5px 0" } },
                                  [_vm._v("C00001730912018083014861")]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c("h3", [_vm._v("三、产品介绍")]),
                        _c("h4", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t3.1 本保险为“雇主责任保险”\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("（具体承保内容以保单及保险条款为准）"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t，针对家电行业的特征，我们对您投保本份保险作以下重要提示：\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t3.1.1\n\t\t\t\t\t\t投保人或被保险人为中华人民共和国境内注册的企业或个体工商户，获得当地市场监督管理局颁发的《营业执照》。\n\t\t\t\t\t\t3.1.2 保障人员必须为接受被保险人（或保单约定的共同被保险人）派工及管理的人员。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.2 投保人/被保险人")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t家电、家居用品、充电桩售后服务网点（单位）为保险合同的投保人/被保险人，被保险人的分销商、二级网点为保险合同的共同被保险人。（本产品仅限于家电、家居用品、充电桩行业销售）\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.3 保险期限")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t自生效日起，保险期限为一年。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.4 特别约定")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t下列特别约定/条款适用于保单的各个部分，均在每份保单当中载明。若其与保单的其他规定相冲突，则以下列特别约定/条款为准。\n\t\t\t\t\t\t3.4.1本保单被保险人雇员为从事家电、家居、充电桩的安装、维护、修理等工作相关人员，投保年龄限16-60周岁（不超60），与被保险人签订有劳动合同或存在事实劳动合同关系，接受被保险人给付薪金、工资，包括正式在册职工、短期工、临时工、季节工和学徒工等相关工作人员。本保单采用记名承保，在保员工以投保人提供的人员名单及其身份证号码为准。\n\t\t\t\t\t\t3.4.2在保险期间内，被保险人的在保人员因从事被保险人所安排的企业经营范围内的工作（不限家电、家居用品、充电桩品牌、品类）而遭受意外事故（包括上下班途中遭受意外事故），或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。\n\t\t\t\t\t\t3.4.3本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、第三者责任、法律费用，每项保障项目的赔偿限额应在保单明确载明。\n\t\t\t\t\t\t3.4.4本保单的共同被保险人包括但不限于保单约定的被保险人及其分销商、二级网点。但是其分销商、二级网点在理赔时需要提供与被保险人的相关合作协议、银行结算清单等关系证明材料。\n\t\t\t\t\t\t3.4.5鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保，本保单所定的保险费率已为最低收费，即短期保费等于保单保费。被保险人申请退保或在保人员批减时，可退保费为0。\n\t\t\t\t\t\t3.4.6被保险人须按雇员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保人员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。\n\t\t\t\t\t\t3.4.7本保险方案仅适用于非高空作业人员，被保险人的在保人员从事高空作业时发生的损失事故，保险人将不承担保险赔偿责任。国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。\n\t\t\t\t\t\t3.4.8在保险期间内，发生保险责任范围内的意外事故，保险人根据被保险人投保的人员名册，对发生死亡、伤残的人员按下列标准赔偿：\n\t\t\t\t\t\t死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。对本保单项下发生的猝死事故，赔付金额以保单约定死亡限额的50%为限。猝死的定义如下：在工作时间和工作岗位上，突发疾病死亡或在48小时之内经抢救无效死亡。\n\t\t\t\t\t\t伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿限额为死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人可提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。\n\t\t\t\t\t\t"
                        ),
                        _c(
                          "h3",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("伤残等级赔偿限额比例表")]
                        ),
                        _c(
                          "table",
                          {
                            staticStyle: { margin: "15px" },
                            attrs: {
                              border: "1",
                              cellpadding: "0",
                              ellspacing: "0",
                              width: "100%",
                            },
                          },
                          [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "50%",
                                    padding: "5px 0",
                                  },
                                },
                                [_vm._v("伤残等级")]
                              ),
                              _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "50%",
                                    padding: "5px 0",
                                  },
                                },
                                [_vm._v("比例")]
                              ),
                            ]),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("一级")]),
                                _c("td", [_vm._v("100%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("二级")]),
                                _c("td", [_vm._v("80%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("三级")]),
                                _c("td", [_vm._v("70%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("四级")]),
                                _c("td", [_vm._v("60%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("五级")]),
                                _c("td", [_vm._v("50%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("六级")]),
                                _c("td", [_vm._v("40%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("六级")]),
                                _c("td", [_vm._v("40%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("七级")]),
                                _c("td", [_vm._v("30%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("八级")]),
                                _c("td", [_vm._v("20%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("九级")]),
                                _c("td", [_vm._v("10%")]),
                              ]
                            ),
                            _c(
                              "tr",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("td", [_vm._v("十级")]),
                                _c("td", [_vm._v("5%")]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n\t\t\t\t\t\t伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。\n\t\t\t\t\t\t3.4.9医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。\n\t\t\t\t\t\t3.4.10医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用（其中检查费以累计2000元为限），但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按80%比例给付医疗保险金。如果被保险人已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。\n\t\t\t\t\t\t3.4.11自费药赔付特别约定：兹经双方同意并约定，在其它规定以保单、批单及保险条款为准的同时，被保险人的在保人员因本保险合同列明的原因所致受伤、残、死亡时，本保单扩展承保医疗费用项下必要的、合理的自费药品部分，但是，每人年累计赔偿限额在保单约定的每人医疗费用责任限额内计算。\n\t\t\t\t\t\t自费药品定义为：除社保甲、乙类用药以外的必须药品，包括乙类药品的自付部分，不包括各种营养类、滋补类药品、保健品、中药和中药饮片，也不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。\n\t\t\t\t\t\t3.4.12误工费赔付特别约定：暂时丧失工作能力且需住院治疗的事故，经二级（含）以上或保险人认可的医疗机构提供合理的证明，保险人按照人民币100元/人/天的标准乘以住院天数（以最长365天为限）计算误工费。但是，一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据(8)款约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险人员的工资证明。出险人员仅需门诊治疗的，按本保单约定无误工费赔付。\n\t\t\t\t\t\t3.4.13扩展工伤事故：被保险人的在保人员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。\n\t\t\t\t\t\t3.4.14扩展承保第三者责任：本保单扩展承保在保险期间内，被保险人的在保人员在从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）时，因意外或疏忽，造成第三者的人身伤亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照本条特别约定，在保险合同载明的本项扩展责任限额内负责赔偿。\n\t\t\t\t\t\t本项扩展责任下，第三者是指除被保险人及其关联单位和关联人员以外的被保险人的工作服务对象，或与被保险人及其投保人员毫无关联关系和亲属、朋友关系的陌生人。\n\t\t\t\t\t\t本项扩展责任下，保单累计赔偿限额RMB100万元，每次事故赔偿限额RMB50万元。同一网点投保多份保单，本项扩展责任的累计赔偿限额和每次事故赔偿限额均以单份保单限额为限，赔偿限额不可叠加。\n\t\t\t\t\t\t以下情况不属于第三者责任的保障范围：\n\t\t\t\t\t\t（1）因驾驶各种机动车辆（包括电动车）发生意外事故导致的第三者人身伤亡；\n\t\t\t\t\t\t（2）装卸、运输货物期间发生意外事故导致的第三者人身伤亡；\n\t\t\t\t\t\t（3）第三者要求被保险人赔偿的间接损失，例如误工费、住宿费等。 （4）第三者的各类财物损坏和财务损失。\n\t\t\t\t\t\t（5）第三者实际从事或协助从事被保险人的工作过程中发生意外事故导致的人身伤亡。\n\t\t\t\t\t\t3.4.15扩展法律费用条款:在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。\n\t\t\t\t\t\t3.4.16本保单不承保高空作业人员。\n\t\t\t\t\t\t3.4.17本保单不承保投保人、被保险人及雇员工作地点属于下述地区的企业：北京市平谷区/密云区/怀柔区、河北省三河市/青龙县/廊坊市、天津市滨海区/静海区、辽宁省铁岭市、山东省禹城/莱州市/滨州市/德州市/临沂市，河南省信阳市/焦作市/新乡市/郏县、四川省宜宾市/雅安市、吉林省四平市、福建省南平下辖、江苏省常州市/连云港市、湖北省黄冈市。\n\t\t\t\t\t\t3.4.18被保险人须在保险事故发生后的48小时内向保险人报案，报案电话95511。超48小时报案，视为延迟报案，保险人对保险责任范围内的损失按绝对免赔率30%定损。因延迟报案致使保险人对保险事故的性质、原因、损失程度等难以查勘定损确定的，保险人对于无法核实确定的部分，不承担赔偿责任。\n\t\t\t\t\t\t以上各条特别约定与主险条款内容相悖之处，以本特别约定为准；未尽之处，以主险条款为准。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.5 保单形式")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。\n\t\t\t\t\t\t"
                        ),
                        _c("h4", [_vm._v("3.6 发票形式")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。\n\t\t\t\t\t\t"
                        ),
                        _c("h3", [_vm._v("四、理赔")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件，并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。\n\t\t\t\t\t\t"
                        ),
                        _c("h3", [_vm._v("五、其他信息")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t5.1我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未授权的第三方。\n\t\t\t\t\t\t5.2您在购买产品过程中，如发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95511。\n\t\t\t\t\t\t5.3若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或中国平安客户服务及投诉热线：95511，我们将安排专人跟进处理。\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }